import { LOCALES } from '@/i18n/routing';
import { CONTACT_ATTACHMENT_MAX_COUNT } from '@/lib/support/contact';
import { z } from 'zod';

export const WORKSPACE_FEEDBACK_MAX_LENGTH = 2000;

export const workspaceFeedbackSchema = z
  .object({
    message: z.string().trim().min(1).max(WORKSPACE_FEEDBACK_MAX_LENGTH),
    name: z.string().trim().max(100),
    email: z.union([z.literal(''), z.email().max(254)]),
    locale: z.enum(LOCALES),
    pagePath: z
      .string()
      .max(2048)
      .regex(/^\/(?!\/)[^\r\n]*$/),
    attachments: z
      .array(
        z
          .object({
            key: z.string().min(1).max(512),
            url: z.url().max(2048),
          })
          .strict()
      )
      .max(CONTACT_ATTACHMENT_MAX_COUNT),
  })
  .strict();

export type WorkspaceFeedbackInput = z.infer<typeof workspaceFeedbackSchema>;
